import React from 'react'
import './CSS/FAQ.css'
const FAQ = () => {
  return (
    <div>
      
    </div>
  )
}

export default FAQ
